<div mat-dialog-content>
    <div class="fixed z-10 inset-0 overflow-y-auto overflow-scroll">
      <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div class="fixed inset-0 transition-opacity">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
          <svg xmlns="http://www.w3.org/2000/svg" mat-button (click)="closeDialog()" class="w-9 h-9 flex absolute right-5 top-3" viewBox="0 0 24 24">
            <path fill="purple" d="M12 3c-4.963 0-9 4.038-9 9s4.037 9 9 9s9-4.038 9-9s-4.037-9-9-9m0 16c-3.859 0-7-3.14-7-7s3.141-7 7-7s7 3.14 7 7s-3.141 7-7 7m.707-7l2.646-2.646a.502.502 0 0 0 0-.707a.502.502 0 0 0-.707 0L12 11.293L9.354 8.646a.5.5 0 0 0-.707.707L11.293 12l-2.646 2.646a.5.5 0 0 0 .707.708L12 12.707l2.646 2.646a.5.5 0 1 0 .708-.706z"/>
          </svg>
  
          <h1 class="text-center p-3 text-2xl font-bold text-purple-700 m-3">Add Bank to Receive your Refund</h1>
          
          <div class="mt-3 text-center sm:mt-0 sm:ml-2 sm:text-left">
            <div class="bg-white p-6 rounded-lg shadow-lg border-2 border-purple-400">
              <h2 class="text-xl font-semibold mb-4">Add Bank Details</h2>
              <form [formGroup]="bankForm" (ngSubmit)="onSubmit()">
                <div class="mb-4">
                  <label for="holder_name" class="block text-sm font-medium text-gray-700">Account Holder Name</label>
                  <input type="text" id="holder_name" formControlName="holder_name" class="mt-1 block w-full p-2 border border-purple-600 rounded-md">
                  <p *ngIf="bankForm.get('holder_name')?.invalid && bankForm.get('holder_name')?.touched" class="text-red-500 text-xs">Please enter your name.</p>
                </div>
                <div class="mb-4">
                  <label for="bank-name" class="block text-sm font-medium text-gray-700">Bank Name</label>
                  <input type="text" id="bank-name" formControlName="bank_name" class="mt-1 block w-full p-2 border border-purple-600 rounded-md">
                  <p *ngIf="bankForm.get('bank_name')?.invalid && bankForm.get('bank_name')?.touched" class="text-red-500 text-xs">Please enter your bank name.</p>
                </div>
                <div class="mb-4">
                  <label for="account-number" class="block text-sm font-medium text-gray-700">Account Number</label>
                  <input type="text" id="account_number" formControlName="account_number" class="mt-1 block w-full p-2 border border-purple-600 rounded-md">
                  <p *ngIf="bankForm.get('account_number')?.invalid && bankForm.get('account_number')?.touched" class="text-red-500 text-xs">Account number must be between 10 and 15 digits.</p>
                </div>
                <div class="mb-4">
                  <label for="ifsc_code" class="block text-sm font-medium text-gray-700">IFSC Code</label>
                  <input type="text" id="ifsc_code" formControlName="ifsc_code" class="mt-1 block w-full p-2 border border-purple-600 rounded-md">
                  <p *ngIf="bankForm.get('ifsc_code')?.invalid && bankForm.get('ifsc_code')?.touched" class="text-red-500 text-xs">IFSC code must be valid.</p>
                </div>
               
                <button  type="submit"
  [disabled]="bankForm.invalid" class="w-full bg-purple-700 text-white p-2 rounded-md hover:bg-purple-600">Add Bank</button>
              </form>
            </div>
          </div>
  
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button mat-button (click)="closeDialog()" class="addbtn inline-flex justify-center w-full text-white p-3 rounded-lg border border-purple-600 px-4 py-2 bg-white text-base leading-6 font-semibold shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">Cancel</button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  